// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2I4ql","checkboxCol":"Table_checkboxCol__3FxVG","emailCol":"Table_emailCol__35n6L","actionCol":"Table_actionCol__3odmu"};